module.exports = __webpack_public_path__ + "img/icon-paperclip.3a572902.svg";